// START Open Requre.JS wrapper
define([
    'require',
    'jquery',
    'shared.main.plugins',
    'foundation.util.keyboard'
], function(require, $, pluginLoader) {
// END Open Require.JS wrapper

/****
 * Adds global event listeners to Foundation.Reveal
 ***/
	var DEBUG = false;
	var PLUGIN_IDENTIFIER = "reveal";
	var vfdpReveal = {

		init: function() {
			if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);
                
            // Initialize events
            this.events();

			return this;
		},

        /**
         * Binds plugin events
         **/
        events: function() {
            var self = this;

            // add custom events when a modal is opened
            $(document).on('open.zf.reveal', self.onModalOpened.bind(this));
        },

        onModalOpened: function(e) {
            var self = this,
                $modal = $(e.target);

            if ( DEBUG ) console.log('modal opened: #' + $modal.prop('id'));

            // check if the modal has a close button
            if($modal.find('[data-close]').length < 1) {
                self.addCloseButton($modal).done(function() {
                    // Untrap the focus so we can retrap with the close button
                    // https://github.com/foundation/foundation-sites/blob/6f3f6cf781d63fe1f3e561da311f9578ac26150a/js/foundation.util.keyboard.js#L132-L161
                    Foundation.Keyboard.releaseFocus($modal);
                    Foundation.Keyboard.trapFocus($modal);
                });
            }

            // check if modal has logon property if so load the logon-register-view.js file
            if (e.currentTarget.hasOwnProperty('Logon') || e.currentTarget.hasOwnProperty('registrationform') || e.currentTarget.hasOwnProperty('nonMemberUpgradeForm')) {
                self.initSignIn($modal);
            }

            // check if modal has loyalty property to load loyalty plugin
            if ($(e.target).find('#loyalty-container').length > 0) {
                self.initLoyalty();
            }
        },

        // Adds a close button to the modal
        addCloseButton: function($modal) {
            var deferred = $.Deferred();
            var self = this,
                $closeButton = $('<button class="close-button" data-close type="button"><span aria-hidden="true" class="icon-close"></span></button>');

            // Lookup the close label if its has not been retrived yet
            if(!self.closeLabel) {
                require(['promise!wcs.lang-msg'], function(){
                    self.closeLabel = window.LANG_MSG['MODAL.LABELS.CLOSE'];
                    if( !self.closeLabel ){
                        self.closeLabel = ""; //Setting a default one, if it is not provided by lang messages
                    }
                    $closeButton.attr('aria-label', self.closeLabel);
                    $modal.prepend($closeButton);
                    deferred.resolve();
                });
            }

            // use existing close label
            else {
                $closeButton.attr('aria-label', self.closeLabel);
                $modal.prepend($closeButton);
                deferred.resolve();
            }
            return deferred;
        },

        // Initialize Sign-In/Registration when loaded within modal
        initSignIn: function($modal) {
            require(["wcs.logon-register-view"], function(LogonRegisterView) {
                $modal.LogonRegisterView();
            });
        },

        // Initialize Loyalty module when loaded within modal
        initLoyalty: function() {
            pluginLoader.loadPlugins({
                name: 'wcs.loyalty-program',
                selector: '#loyalty-container',
                initFunction: 'init'
            });
        }
	};

	return vfdpReveal.init();
});